import { SVGProps } from "react";

const Time = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.9683 10C17.9683 14.14 14.6083 17.5 10.4683 17.5C6.32826 17.5 2.96826 14.14 2.96826 10C2.96826 5.86 6.32826 2.5 10.4683 2.5C14.6083 2.5 17.9683 5.86 17.9683 10Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9683 12.5001L11.0688 11.0931C10.7379 10.8497 10.4683 10.2641 10.4683 9.78496V6.66675"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default Time;
